if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sectionWrapper: '.featured-collection',
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
          controls: '.swiper-controls'
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.section = this.closest(this.selectors.sectionWrapper);
        this.blockId = this.dataset.blockId;
        this.block = this.closest(`[data-id="${this.blockId}"`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.controls = this.section.querySelector(`${this.selectors.controls}[block-id="${this.blockId}"]`);
        this.arrows = this.querySelectorAll('.swiper-arrow');
        this.paginationItems = this.section.querySelectorAll('[role="swiper-pagination-item"]');

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = this.dataset.items !== 'auto' ? parseInt(this.dataset.items) : 'auto';
        this.tabletItems = this.dataset.items !== 'auto' ? parseInt(this.dataset.tabletItems) : 'auto';
        this.laptopItems = this.dataset.items !== 'auto' ? parseInt(this.dataset.laptopItems) : 'auto';
        this.itemsPerGroup = this.dataset.itemsPerGroup;
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: 'auto',
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.controls?.querySelector(this.selectors.nextEl),
            prevEl: this.controls?.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.controls?.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
              slidesPerGroup: this.itemsPerGroup === 'single' ? 1 : this.tabletItems
            },
            1024: {
              slidesPerView: this.laptopItems,
              slidesPerGroup: this.itemsPerGroup === 'single' ? 1 : this.laptopItems
            },
            1280: {
              slidesPerView: this.items,
              slidesPerGroup: this.itemsPerGroup === 'single' ? 1 : this.items
            },
          },
          loop: true,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        if (this.arrows?.length) {
          this.arrows.forEach(arrow => arrow.addEventListener('click', () => {
            const selector = arrow.name === 'next' ? this.selectors.nextEl : this.selectors.prevEl;
            this.controls.querySelector(selector)?.dispatchEvent(new Event('click'));
          }))
          this.updateArrowStatus();
          this.sliderInstance.slider.on('realIndexChange', this.updateArrowStatus.bind(this));
        }

        if (this.paginationItems?.length) {
          this.paginationItems?.forEach(paginationItem => paginationItem.addEventListener('click', () => {
            const index = Number(paginationItem.dataset.index);
            this.sliderInstance.slider.slideTo(index + 1);
          }))
          this.sliderInstance.slider.on('realIndexChange', ({realIndex}) => {
            this.paginationItems?.forEach(paginationItem => {
              const index = Number(paginationItem.dataset.index);
              console.log(index, realIndex);
              paginationItem.classList.toggle('active', index === realIndex);
            })
          });
        }

        this.calcNavButtonsPosition();
        this.fixQuickviewDuplicate();
      }

      updateArrowStatus() {
        this.arrows.forEach(arrow => {
          const selector = arrow.name === 'next' ? this.selectors.nextEl : this.selectors.prevEl;
          const btn = this.controls?.querySelector(selector);
          if (btn) {
            arrow.disabled = btn.disabled;
          }
        })
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== 'center_image') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        const controls = this.block.querySelector('.swiper-controls');
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
        }
      }
    }
  );
}
